import React from 'react';

import './style.scss';

interface Props {
  children: JSX.Element[] | JSX.Element;
}

export const CardBody = ({ children }: Props) => {
  return <div className="card__card-body">{children}</div>;
};
